import React from 'react';
import PropTypes from 'prop-types';

import SnukTable from './SnukTable';

const TableWithFetch = props => (
  <SnukTable {...props} fetcher />
);

TableWithFetch.propTypes = {
  ...SnukTable.propTypes,
  fetchAction: PropTypes.func.isRequired, // the Redux action to fetch the data
  isLoading: PropTypes.bool.isRequired,
};

export default TableWithFetch;



// WEBPACK FOOTER //
// ./src/components/reusable/TableWithFetch.js